
import Vue from 'vue';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import Card from '@/components/Card/index.vue';
import Modal from '@/components/Modal/index.vue';
import Footer from '@/components/Footer/index.vue';
import HeaderPenalty from '@/components/HeaderPenalty/index.vue';
import Tag from '@/components/Tag/index.vue';
import getTerritoryByCarCodeService from '@/services/territory/get-territory-by-car-code';
import { getContestationbyID } from '@/services/contestation/get-contestation-by-id';
import VueQRCodeComponent from 'vue-qrcode-component';
import getTerritoryByIdService from '@/services/territory/get-territory-by-id';
import Accordion from '@/components/Accordion/index.vue';
import getAct from '@/services/act/get-act';
import Button from '@/components/Button/index.vue';
import getTickets from '@/services/tickets/get-tickets';
import apiGixget from '@/services/appoinments/get-gix';
import getPenalty from '@/services/tickets/get-penalty';
import { getAgent } from '@/services/user/get-agent';
import { getCofre } from '@/services/tickets/get-cofre';
import Radio from '@/components/RadioButton/index.vue';
import { GetReportParms, getReport } from '@/services/territory/get-report';
import { updateConstestation } from '@/services/contestation/update-contestation';
import { capitalizeFirstLetter } from '@/utils/capitalize-first-letter';
import getTerritoryPenaltyStatus from '@/services/territory/get-territory-penalty-status';
import {
  DueData, TerritoryViolation, TerritoryPenaltyStatus, TerritoryPenaltyStatusEnum,
} from '@/config/types';
import { getViolations } from '@/services/territory/get-violations';
import { generatePenalty } from '@/services/territory/generate-penalty';
import postPenalty from '@/services/tickets/post-penalty';
// import getTerritoryPenaltyStatus from '@/services/territory/get-territory-penalty-status';
import updateTerritoryPenaltyStatus from '@/services/territory/update-territory-penalty-status';
import { getUserGroup } from '@/utils';

import constants from '@/config/constants';
import {
  Container, Main,
} from './styles';

Vue.component('qr-code', VueQRCodeComponent);

export default Vue.extend({
  props: ['id'],
  components: {
    Card,
    Container,
    Footer,
    HeaderPenalty,
    Main,
    Tag,
    Modal,
    Radio,
    Button,
    Accordion,
  },
  data() {
    return {
      status: '',
      visibleModal: true,
      dataPenalty: {} as any,
      checkedAnalisad: true,
      conditionName: '',
      nameItem: false,
      territoryCar: [],
      totalPenalty: {
        totalAmount: 0,
        cdTerritory: '',
        totalInstallments: 0,
      },
      territoryViolations: [] as TerritoryViolation[],
      agentId: '',
      filter: '',
      penaltyStatus: true,
      territoryEditionModal: false,
      territory: {
        loaded: false,
        territoryEditionModal: false,
        agents: [{
          id: '',
        }],
        city: '',
        force: '',
        name: '',
        car: '',
        id: '',
        documents: [],
      },
      qrCode: '',
      month: 0,
      dateContestation: '',
      infoContestation: {} as any,
      documentProp: '',
      actData: {} as any,
      territoryPenaltyStatus: {} as TerritoryPenaltyStatus,
      gixData: {} as any,
      statusFlag: {} as TerritoryPenaltyStatus,
      linkActPdf: '',
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      territoryArray: [] as any[],
      objAct: {} as any,
      dataCdTerritory: {
        cdTerritory: '',
      } as any,
      loaded: true,
      tickets: {} as any,
      headerColumns: ['Tipo', 'Data de Inicio', 'Fim do prazo', 'Status', 'Resultado', 'PDF'],
      territoryByCar: {
        loaded: false,
        aderiuPRA: '',
        area: '',
        dataAnalise: '',
        dataRegistro: '',
        dataRetificacao: '',
        latitude: '',
        longitude: '',
        modulosFiscais: '',
        statusImovel: '',
        condicaoAnalise: '',
      },
      report: {
        type: 'termSocioEnvironmental',
      } as any,
      params: {
        territoryId: '',
        tokenKey: '',
        status: '',
      } as any,
      digitalSafe: '',
    };
  },
  computed: {
    ...mapGetters(['DateById', 'DateAct']),
    getAppointment(): any[] {
      return this.territoryArray.map((appointment) => {
        const dateStart = moment(appointment.dtAppointment || appointment.createdOn);
        const dateEnd = appointment.dtAppointment
          ? moment(appointment.dtAppointment).add(7, 'days')
          : moment(appointment.act);

        return {
          type: appointment?.type?.type || 'ACT',
          dtAppointment: dateStart.format('L'),
          dtEnd: dateEnd.format('L'),
          status: appointment.status || 'Em andamento',
          result: 'Aprovado',
        };
      }).sort((date1, date2) => this.IsEqualDate(date1.dtAppointment, date2.dtAppointment));
    },
    getDocKey(): object {
      return {
        tercom: 'Termo de compromisso',
        termsocioenvironmental: 'Analise socioambiental',
      };
    },
    getDocs(): any[] {
      return [...this.territory.documents, this.report].map((doc) => {
        const docName = this.getDocKey[doc.type?.toLocaleLowerCase()];

        if (docName) {
          return {
            name: capitalizeFirstLetter(docName),
            url: doc.url || doc.urlExtract,
          };
        }
        return null;
      }).filter(Boolean);
    },
  },
  methods: {
    ...mapActions({ getAppointmentDate: 'getAppointmentDate' }),
    IsEqualDate(date1: string, date2: string) {
      return moment(date1, 'DD/MM/YYYY').unix() - moment(date2, 'DD/MM/YYYY').unix();
    },
    hasChecked() {
      this.penaltyStatus = true;
    },
    async checked(value) {
      this.penaltyStatus = value;
      this.params.territoryId = this.territory.id;
      this.params.tokenKey = this.userLoged.company.stKey;
      this.params.status = value;
      if (value === 'Analisado') {
        this.conditionName = 'Analisado';
        this.checkedAnalisad = true;
        /* eslint no-multi-assign: "error" */
        this.nameItem = true;
      } else if (value === 'Rejeitado') {
        this.generateTerritoryPenalty();
        this.checkedAnalisad = false;
      }
      await updateConstestation(this.params);
    },
    async getData() {
      this.territoryViolations = await this.getTerritoryViolations();
    },
    async getTerritoryViolations() {
      const dueDataRequest = this.generateDueDataRequest();
      return getViolations(dueDataRequest);
    },
    generateDueDataRequest(): DueData {
      const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
      return {
        cdTerritory: this.$route.params.id,
        tokenKey: userLogged?.company?.stKey,
        fkUser: `${userLogged?.idUser.toString()}`,
        cdCompany: `${userLogged?.company.idCompany.toString()}`,
        cdAnalysis: `${process.env.VUE_APP_ANALISE}`,
      };
    },
    getFormData() {
      const data = this.territoryViolations;
      // eslint-disable-next-line no-param-reassign
      data.map((x) => x.violatedAreas.filter((violatedArea) => violatedArea.area === '').map((a) => { a.area = '0'; return a; }));
      return data;
    },
    async generateTerritoryPenalty() {
      /* eslint max-len: ["error", { "code": 199 }] */
      const loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });
      const dueDataRequest = this.generateDueDataRequest();
      let result = null;
      result = await generatePenalty(dueDataRequest);
      if (result !== null) {
        await updateTerritoryPenaltyStatus(this.$route.params.id, TerritoryPenaltyStatusEnum.pendingPaymentReview)
          .then(() => {
            // @ts-ignore
            this.totalPenalty.totalAmount = result.data.objectResult.penaltyValue;
            this.totalPenalty.cdTerritory = this.$route.params.id;
            // @ts-ignore
            this.totalPenalty.totalInstallments = result.data.objectResult.totalInstallments;
            postPenalty(this.totalPenalty).then((e) => {
              Vue.swal('', e.message, 'success');
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            });
          });
      }
      loader.hide();
    },
    unchecked() {
      this.penaltyStatus = false;
    },
    async getTerritoryById() {
      /* eslint max-len: ["error", { "code": 130 }] */
      const { id } = this.$route.params;

      const response = await getTerritoryByIdService(id);
      if (response.hasErrors) this.$router.push('/not-found');

      this.territory = response.objectResult;

      this.territory.loaded = true;

      if (this.isAdminUser()) {
        this.territoryPenaltyStatus = await this.getTerritoryPenaltyStatus(id);
      }

      let documentCAR;

      if (response.objectResult.documents) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.territory.documents.forEach((document: any, index) => {
          if (document.type === 'TERCOM') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this as any).territory.documents[index].title = document.title !== '' ? document.title : this.$t('terms');
          }
        });
        documentCAR = response.objectResult.documents.find(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (document: any) => document.type.includes('CARDOC'),
        );
      }

      if (documentCAR) {
        this.territory.car = documentCAR.title;
        this.getTerritoryByCarCode(this.territory.car);
      } else {
        this.territoryByCar.loaded = true;
      }
    },
    openPix() {
      this.$router.push(`/paypix/${this.$route.params.id}`);
    },
    payPix(value) {
      this.territoryEditionModal = true;
      this.visibleModal = true;
      this.qrCode = value;
    },
    close() {
      this.territoryEditionModal = false;
      this.visibleModal = false;
    },
    goToGeo(dataType: string, dataInitial: string, dataEnd: string) {
      if (dataType === 'Geomonitoramento') {
        this.$router.push({ name: 'Geomonitoramento', params: { dataStart: dataInitial, dataEnd } });
        return;
      }

      if (dataType === 'Autovistoria') {
        this.$router.push({ name: 'Autovistoria', params: { dataStart: dataInitial, dataEnd } });
      }
    },
    goToPenaltyPage() {
      /* eslint max-len: ["error", { "code": 266 }] */
      this.$router.push({ name: 'Penalty', params: { id: this.territory.id, car: this.territory.car }, append: false });
    },
    async getTerritoryByCarCode(carCode: string) {
      const { objectResult } = await getTerritoryByCarCodeService(carCode);

      if (objectResult) this.territoryByCar = objectResult.dadosExtratoPdf;

      this.territoryByCar.loaded = true;
    },
    async verifyPenalty() {
      const { id } = this.$route.params;
      this.statusFlag = await this.getTerritoryPenaltyStatus(id);
    },
    async getPenaltyVerify() {
      this.dataPenalty = await getPenalty(this.territory.id);
    },
    getReportRequest() {
      const params: GetReportParms = {
        cdUser: this.userLoged.idUser,
        tokenKey: this.userLoged.company.stKey,
        cdTerritory: this.id,
      };
      getReport(params).then((data) => { this.report = { ...this.report, ...data }; });
    },
    isAdminUser() {
      return getUserGroup() === constants.roles.admin;
    },
    getTerritoryPenaltyStatus(territoryId: string) {
      return getTerritoryPenaltyStatus(territoryId);
    },
    displayPenaltyPageButton() {
      return this.isAdminUser() && this.territoryPenaltyStatus.id === TerritoryPenaltyStatusEnum.pending;
    },
  },
  async created() {
    await this.getTerritoryById();
    this.getPenaltyVerify();
    const { idUser } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
    const bearer = sessionStorage.getItem('chave') || '{}';
    const stKey = this.userLoged.company.stKey.toString();
    const resp = await getContestationbyID(stKey, this.territory.id);
    this.infoContestation = resp.objectResult;
    this.status = this.infoContestation[0].status;
    this.gixData = apiGixget(idUser, bearer, stKey);
    this.dataCdTerritory.cdTerritory = this.territory.id;
    this.actData = await getAct(company.stKey, this.territory.id);
    this.tickets = await getTickets({ cdTerritory: this.territory.id });
    this.gixData.then((e) => {
      this.objAct = e.data.objectResult;
    });
    this.verifyPenalty();
    this.documentProp = this.$route.params.document;
    const tokenKey = this.userLoged.company.stKey;
    const document = this.documentProp.replace(/[^0-9]/g, '');
    const agentId = await getAgent({ tokenKey, document });
    const agentIdItem = agentId.id;
    const response = await getCofre(tokenKey, agentIdItem);
    response.map((e) => {
      if (e.cdTerritory === this.$route.params.id) {
        e.digitalSafes.map((k) => {
          if (k.vlUrlDownload !== '' && k.nmFileType?.toUpperCase()?.includes('CONTDOC')) {
            this.dateContestation = k.dtUpload;
            this.digitalSafe = k.vlUrlDownload;
            return k;
          }
          return false;
        });
        return e;
      }
      return false;
    });
  },
});
